import * as actionCreators from '../../redux/files/actionCreators';
import { addDefaultFileValues } from '../../utils/redux/redux';
import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { connect } from 'react-redux';

import addNotification from '../../../../../__util__/notifications';
import Button from '../../../../../primitives/form/button/Button';

export function UploadDropzone(props) {
  const { awsConfig, setAwaitingFileSelectionFalse, setFiles, notificationDomRef, infoFields } = props;

  // TODO: Write a test for this hook
  // Currently (7th May 2019) can't as Enzyme doesn't support Hooks yet
  // https://github.com/airbnb/enzyme/issues/2011
  /* istanbul ignore next */
  const onDrop = useCallback(async (files, infoFields, notificationDomRef) => {
    if (files.length > 100) {
      addNotification(
        notificationDomRef.current,
        'Too Many Files',
        'File uploading is limited to 100 files at a time. Please try again with fewer files.',
        'danger',
      );

      return;
    }

    setAwaitingFileSelectionFalse();
    setFiles(addDefaultFileValues(files, infoFields));
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (files) => {
      onDrop(files, infoFields, notificationDomRef);
    },
  });

  return (
    <div className="uploader__dropzone" {...getRootProps()}>
      <input {...getInputProps()} />
      <div className="uploader__dropzone-container">
        <Button name="ADD YOUR FILES" buttonType="primary" elementType="link" href="#" />
        <span>or drag and drop</span>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    awsConfig: state.awsConfig.awsConfig,
    infoFields: state.infoFields.infoFields,
    notificationDomRef: state.internal.notificationDomRef,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setAwaitingFileSelectionFalse: () => {
      dispatch(actionCreators.setAwaitingFileSelectionFalse());
    },
    setFiles: (fileArray) => {
      dispatch(actionCreators.setFiles(fileArray));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadDropzone);
